import ReactGA from 'react-ga';

export const InitAnalytics = (history) => {
	ReactGA.initialize('UA-160833791-1');
	history.listen(location => {
		ReactGA.set({page: location.pathname});
		ReactGA.pageview(location.pathname);
	})
}